/** Visible page numbers for pagination UI (current ± window, always includes 1 and last). */
export function buildPaginationWindow(current: number, total: number, windowRadius = 2): number[] {
  if (total <= 0) return [];
  if (total === 1) return [1];
  const pages = new Set<number>([1, total, current]);
  for (let i = current - windowRadius; i <= current + windowRadius; i += 1) {
    if (i >= 1 && i <= total) pages.add(i);
  }
  return Array.from(pages).sort((a, b) => a - b);
}
